<script setup lang="ts">
import type { SubmenuList, SubmenuListItem } from '../types/mainNav';
import ChevronRightIcon from './icons/ChevronRightIcon.vue';
import CustomLink from '@pkg/link/src/components/CustomLink.vue';

defineProps<{
  list: SubmenuList;
}>();

const getLink = (subItem: SubmenuListItem) => subItem.reference ? subItem.reference : subItem;
</script>

<template>
  <ul class="nav__col-list" :aria-labelledby="list.submenuListTitle">
    <li v-for="(subItem, k) in list.submenuListItems" :key="k">
      <span v-if="subItem.reference || subItem.url" class="c-nav-item">
        <CustomLink :link="getLink(subItem)">
          {{ subItem.title }}
        </CustomLink>
        <ChevronRightIcon class="c-nav-item__chevron" />
      </span>
      <span v-else>{{ subItem.title }}</span>
    </li>
  </ul>
</template>

<style>
.nav__col-list {
  display: flex;
  flex-direction: column;
  list-style: none;
  gap: theme('spacing.14');
  font-size: theme('fontSize.16');
  padding-top: theme('spacing.8');

  @screen desk-small {
    padding-bottom: theme('spacing.8');
  }
}

.c-nav-item {
  position: relative;
  display: inline-flex;
  align-items: flex-start;
  padding-right: theme('spacing.32');
  margin-right: theme('spacing.24');

  @screen desk-small {
    margin-right: 0;
  }

  &__chevron {
    position: absolute;
    right: 0;
    top: 50%;
    width: 1.25em;
    height: 1.25em;
    opacity: 0;
    transform: translateY(-50%) translateX(-6px);
    transition: opacity theme('transitionDuration.goat') theme('transitionTiming.ease-out'),
      transform theme('transitionDuration.goat') theme('transitionTiming.ease-out');
      padding-top: 1.75px;
  }

  &:hover &__chevron {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }

  &--selected,
  &:has(.router-link-active) .router-link-active {
    text-decoration: underline;
  }
}
</style>
